import React from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import './styles.scss';

const BreadCrumbs = ({ navigationLinks }) => {
  return (
    <div className="breadcrumbs__wrapper">
      <Breadcrumb>
        {navigationLinks?.map((item, index) => (
          <Breadcrumb.Item key={index} href={item.url} active={item.isActive}>
            {item.name}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  );
};

export default BreadCrumbs;
